<ion-header
  class="ion-no-border"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons slot="end" *ngIf="platform === platformRef.desktop">
      <ion-button
        id="close-modal-btn"
        (click)="dismiss()"
        data-cy="copy-list-close-modal-button"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-label data-cy="copy-list-option-text">
      {{ 'i18n.menuProfitPro.recipeDetail.addIngredient' | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  tabletTouchMove
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <div
    class="search-bar-container"
    [ngClass]="
      platform !== platformRef.desktop
        ? platform === platformRef.tablet
          ? 'tablet'
          : 'mobile'
        : 'desktop'
    "
  >
    <ion-searchbar
      [placeholder]="
        'i18n.menuProfitPro.addIngredient.searchPlaceholder' | translate
      "
      data-cy="ingredents-searchbar"
      class="search"
      mode="md"
      [(ngModel)]="searchKey"
      (ionInput)="onSearch()"
      (ionClear)="resetSearch()"
    >
    </ion-searchbar>
  </div>
  <div class="add-non-usf-container">
    <ion-button
      data-cy="add-non-usf-modal-button"
      [ngClass]="'usf-outline-green-dsktp-tblt-modal-button'"
    >
      {{ 'Add Non USF Product' | translate }}
      <ion-icon name="add-outline"></ion-icon>
    </ion-button>
  </div>

  <div
    class="search-results-container"
    [class.desktop]="platform === platformRef.desktop"
  >
    <ng-container
      *ngIf="platform === platformRef.desktop"
      [ngTemplateOutlet]="desktop"
    ></ng-container>
    <ng-container
      *ngIf="platform === platformRef.tablet"
      [ngTemplateOutlet]="tablet"
    ></ng-container>
    <ng-container
      *ngIf="platform === platformRef.mobile"
      [ngTemplateOutlet]="mobile"
    ></ng-container>
  </div>
</ion-content>

<ng-template #desktop>
  <div class="left-side">
    <div class="recipes">
      <app-ingredient-search-recipe
        [viewAllState]="viewRef.ICON_AND_TEXT"
        (clickEvent)="viewAllRecipeRequest()"
        (selectIngredientToAddEvent)="selectIngredientToAdd($event)"
        [ingredientSearchResult$]="recipeSearchResult"
      ></app-ingredient-search-recipe>
    </div>
    <!-- <hr />
    <div class="on-list">
      <app-ingredient-search-on-list
        [viewAllState]="viewRef.ICON_AND_TEXT"
        (clickEvent)="viewAllOnListRequest()"
        [ingredientSearchResult$]="myListSearchResult"
      ></app-ingredient-search-on-list>
    </div> -->
  </div>
  <div class="products right-side">
    <app-ingredient-search-product
      [platform]="platform"
      [viewAllState]="viewRef.ICON_AND_TEXT"
      (selectIngredientToAddEvent)="selectIngredientToAdd($event)"
      [ingredientSearchResult$]="productSearchResult"
      [searchTimeoutTracker]="searchTimeoutTracker"
      (viewAllEvent)="viewAllProductsRequest()"
    ></app-ingredient-search-product>
  </div>
</ng-template>

<ng-template #mobile>
  <div class="products">
    <app-ingredient-search-product
      [platform]="platform"
      [viewAllState]="viewRef.ICON_AND_TEXT"
      (selectIngredientToAddEvent)="selectIngredientToAdd($event)"
      [ingredientSearchResult$]="productSearchResult"
      [searchTimeoutTracker]="searchTimeoutTracker"
      (viewAllEvent)="viewAllProductsRequest()"
    ></app-ingredient-search-product>
  </div>
  <hr />
  <div class="recipes">
    <app-ingredient-search-recipe
      [viewAllState]="viewRef.ICON_AND_TEXT"
      (clickEvent)="viewAllRecipeRequest()"
      (selectIngredientToAddEvent)="selectIngredientToAdd($event)"
      [ingredientSearchResult$]="recipeSearchResult"
    ></app-ingredient-search-recipe>
  </div>
  <!-- <hr /> -->
  <!-- <div class="on-list">
    <app-ingredient-search-on-list
      [viewAllState]="viewRef.ICON_AND_TEXT"
      (clickEvent)="viewAllOnListRequest()"
      [ingredientSearchResult$]="myListSearchResult"
    ></app-ingredient-search-on-list>
  </div> -->
</ng-template>

<ng-template #tablet>
  <div class="products">
    <app-ingredient-search-product
      [platform]="platform"
      [viewAllState]="viewRef.ICON_AND_TEXT"
      (viewAllEvent)="viewAllProductsRequest()"
      (selectIngredientToAddEvent)="selectIngredientToAdd($event)"
      [ingredientSearchResult$]="productSearchResult"
      [searchTimeoutTracker]="searchTimeoutTracker"
    ></app-ingredient-search-product>
  </div>
  <hr />
  <div class="recipes">
    <app-ingredient-search-recipe
      [viewAllState]="viewRef.ICON_AND_TEXT"
      (clickEvent)="viewAllRecipeRequest()"
      (selectIngredientToAddEvent)="selectIngredientToAdd($event)"
      [ingredientSearchResult$]="recipeSearchResult"
    ></app-ingredient-search-recipe>
  </div>
  <!-- <hr /> -->
  <!-- <div class="on-list">
    <app-ingredient-search-on-list
      [viewAllState]="viewRef.ICON_AND_TEXT"
      (clickEvent)="viewAllOnListRequest()"
      [ingredientSearchResult$]="myListSearchResult"
    ></app-ingredient-search-on-list>
  </div> -->
</ng-template>
